import { all, Effect, fork, take } from "redux-saga/effects";
import { PayloadAction } from "typesafe-actions";

import { authSagas } from "./auth/auth.saga";
import { chatsServices } from "./chat/chat.saga";
import { fetchActivePhones } from "./active-phones/active-phones.saga";
import { chatsFoldersSaga } from "./chat/folders/folders.saga";
import { archiveSaga } from "./chat/archive/archive.saga";
import { searchWatchers } from "./chat/search/search.saga";
import { messagesSaga } from "./messages/messages.saga";
import { setIsAuth } from "./auth/auth.actions";
import { callsServices } from "./calls/calls.saga";

import { versionInfo } from "~/app/utils/version";
import { errorSaga } from "./error/error.saga";

function* runSagas(): Generator<Effect, void, PayloadAction<string, boolean>> {
  while (true) {
    const { payload }: PayloadAction<string, boolean> = yield take(setIsAuth);

    if (payload) {
      yield all([
        fork(fetchActivePhones),
        fork(chatsServices),
        fork(messagesSaga),
        fork(callsServices),
        fork(archiveSaga),
        fork(searchWatchers),
        fork(chatsFoldersSaga)
      ]);
    }
  }
}

export default function* rootSaga(): Generator<Effect, void, void> {
  console.info(versionInfo());

  yield all([fork(authSagas), fork(runSagas), fork(errorSaga)]);
}
